export default "__VITE_ASSET__CVEpw9Yi__"